<script>
import InputLine from '@/components/atoms/inputlib/components/InputLine'
import InputSelect from '@/components/atoms/inputlib/components/InputSelect'
import { mapGetters } from 'vuex'
import debounce from 'lodash.debounce'

export default {
    name: 'Contributor',
    components: { InputLine, InputSelect },
    props: {
        value: null,
        employees: {
            type: Array,
            default: () => [],
        },
        contributor: {
            type: Object,
            default: () => {},
        },
        currency: {
            type: Object,
            default: () => {},
        },
        manualPrice: Boolean,
        readonly: Boolean,
        error: Boolean,
        highlight: Boolean,
        loading: Boolean,
        select: Boolean,
    },
    data() {
        return {
            onInput: debounce((val) => {
                this.$emit('input', val)
            }, 500),
            selected: null,
        }
    },
    computed: {
        ...mapGetters(['smDevice', 'lgDevice']),
        isHu() {
            return this.currency.country_code === 'hu'
        },
    },
    methods: {
        remove() {
            this.$emit('remove')
        },
        onSelect(contributor) {
            if (contributor?.email && !this.contributor.email) this.$emit('select', contributor)
        },
    },
}
</script>

<template lang="pug">
.contributor-row.row.mb-4.mx-n2
    .col-12.col-md-8.px-2.d-flex
    
        transition(name="fade" mode="out-in")
            .contributor(v-if="!select")
                span.text-ellipsis.pr-3(:title="`${contributor.name ? contributor.name+' - ' : ''}${contributor.email}`")
                    span
                        template(v-if="contributor.name") {{contributor.name}}&nbsp;-&nbsp;
                        template(v-if="contributor.email") {{contributor.email}}
                span
                    icon.text-99.mr-2(icon="fa-solid fa-wallet")
                    span {{contributor.budget - contributor.contribution  | toCurrency(currency.locale, currency.currency_code)}}
                    span &nbsp;{{ $t('order.remaining') }}
            input-select.mw-100.w-100(
                v-else
                :value="contributor"
                @input="onSelect"                 
                :class="{'form-highlight': highlight}" 
                :options="employees" 
                :max-height="200" 
                :key="`select-${employees ? employees.length : 'x'}`" 
                track-by="email"
                :search-by="['email', 'name', 'budget']"
                :loading="loading"
                open-direction="top"
                searchable)
                template(v-slot:singleLabel="prop")
                    .d-flex.flex-wrap.justify-content-between.align-items-center(v-if="prop")
                        .text-ellipsis.font-size-base(:class="{'max-w-fix-250': lgDevice}" :title="`${prop.option.name ? prop.option.name+' - ' : ''}${prop.option.email}`")
                            template(v-if="prop.option.email") {{prop.option.name}}&nbsp;-&nbsp;
                            template {{prop.option.email}}
                        span.font-size-base.ml-auto {{prop.option.budget | toCurrency(currency.locale, currency.currency_code)}}
                template(v-slot:option="prop")
                    .d-flex.flex-column.flex-sm-row.justify-content-between.align-items-center(v-if="prop")                     
                        .text-ellipsis.font-size-base(:class="{'max-w-fix-250': lgDevice}"  :title="`${prop.option.name ? prop.option.name+' - ' : ''}${prop.option.email}`")
                            template(v-if="prop.option.email") {{prop.option.name}}&nbsp;-&nbsp;
                            template {{prop.option.email}}
                        span.font-size-base.ml-auto {{prop.option.budget | toCurrency(currency.locale, currency.currency_code)}}
    .col-12.col-md-4.px-2.d-flex
        input-line.mb-0.contribution(
            :value="value"
            @input="onInput"
            :error="error"
            :min="0"
            :step='!isHu ? 1 : 0.01'
            :class="{'manual-price': manualPrice}"
            :input-group="currency.currency_sign"
            type="number"
            :readonly="readonly || select"
            :prepend="!isHu"
            hide-step)
        .c-remove
            button.btn.btn-transparent.btn-icon(@click="remove" :disabled="(readonly ||  !contributor.removable) && !select")
                icon(icon="fa-solid fa-trash")

</template>
<style scoped>
.contributor-row >>> .multiselect__single {
    padding-left: 0 !important;
}
</style>
